import { IconButton, TableCell, TableRow } from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useAppSelector } from "../../../app/hooks";
import { routes } from "../../../app/paths";
import IconWrapper from "../../../common/components/functional/icons/IconWrapper";
import { localizeNames } from "../../../common/helpers/common";
import { leadingZerosDateFormat } from "../../../common/helpers/formatDateTime";
import { ReactComponent as DeleteIcon } from "../../../common/icons/deleteDark.svg";
import { ReactComponent as EditIcon } from "../../../common/icons/editDark.svg";
import theme from "../../../theme";
import { TalentExclusivity } from "../../talents/talentAPI";

type Props = {
  entry: TalentExclusivity;
  onEditClick: (entry: TalentExclusivity) => void;
  onDeleteClick: (id: string, version: number) => void;
};

const ExclusivityRow = ({ entry, onEditClick, onDeleteClick }: Props) => {
  const { t } = useTranslation();
  const { localized } = useAppSelector((state) => state);
  const workTitleNames = localizeNames(localized.workTitle, entry.workTitles);

  return (
    <TableRow key={entry.id}>
      <TableCell width="15%">
        <Link
          to={routes.customerBasicInfo(entry.customerCompanyId, {
            org: entry.customerOrganizationId,
          })}
          style={{
            textDecoration: "none",
            color: theme.palette.primary.main,
          }}
        >
          {entry.customerCompanyName}
        </Link>
      </TableCell>
      <TableCell width="15%">
        {entry.customerOrganizationName || t("talentProfile:allAllowed")}
      </TableCell>
      <TableCell width="15%">
        {entry.workLocationName || t("talentProfile:allAllowed")}
      </TableCell>
      <TableCell width="15%">
        {workTitleNames || t("talentProfile:allAllowed")}
      </TableCell>
      <TableCell width="5%">
        {entry.createdAt &&
          format(new Date(entry.createdAt), leadingZerosDateFormat)}
      </TableCell>
      <TableCell width="5%" />
      <TableCell width="26%" />
      <TableCell
        width="2%"
        sx={{
          whiteSpace: "nowrap",
          minWidth: "90px",
          padding: 0,
          paddingRight: 1,
          textAlign: "right",
        }}
      >
        <IconButton
          onClick={() => onEditClick(entry)}
          sx={{ width: 44, height: 44 }}
        >
          <IconWrapper
            icon={EditIcon}
            sx={{
              fill: "none",
              stroke: "#000000de",
              width: 18,
              height: 18,
              viewBox: "0 0 28 28",
            }}
          />
        </IconButton>
        <IconButton onClick={() => onDeleteClick(entry.id, entry.version)}>
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default ExclusivityRow;
